import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Code2, Cloud, Zap, Smartphone } from 'lucide-react';
export function TechSection() {
  const technologies = [{
    icon: <Code2 className="w-8 h-8 text-white" data-id="element-357" />,
    title: 'Integración API Restful',
    description: 'APIs modernas, bien documentadas y fáciles de implementar. Conecta tu plataforma en horas, no semanas.'
  }, {
    icon: <Cloud className="w-8 h-8 text-white" data-id="element-358" />,
    title: 'Infraestructura Cloud',
    description: 'Arquitectura nativa en la nube que garantiza 99.99% de uptime y escalabilidad automática según la demanda.'
  }, {
    icon: <Zap className="w-8 h-8 text-white" data-id="element-359" />,
    title: 'Escalabilidad Total para Flujos Masivos',
    description: 'Motor transaccional de alto rendimiento capaz de procesar miles de operaciones por segundo sin latencia.'
  }, {
    icon: <Smartphone className="w-8 h-8 text-white" data-id="element-360" />,
    title: 'Arquitectura Multiplataforma',
    description: 'Soluciones diseñadas para funcionar perfectamente en web, móvil, kioskos de autoatención, POS y sistemas integrados.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="tecnologia" className="py-24 bg-gray-50" data-id="element-361">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-362">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-363">
          <h2 className="text-lg font-bold text-zumpago-red tracking-wider uppercase mb-3" data-id="element-364">
            Tecnología
          </h2>
          <h3 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-365">
            Infraestructura de clase mundial
          </h3>
          <p className="text-lg text-gray-600" data-id="element-366">
            Construimos sobre las tecnologías más avanzadas para ofrecerte una
            plataforma robusta, segura y preparada para el futuro.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-367">
          {technologies.map((tech, index) => <motion.div key={index} variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-shadow border border-gray-100 group" data-id="element-368">
              <div className="w-16 h-16 rounded-2xl bg-zumpago-dark flex items-center justify-center mb-6 group-hover:bg-zumpago-red transition-colors duration-300" data-id="element-369">
                {tech.icon}
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4" data-id="element-370">
                {tech.title}
              </h4>
              <p className="text-gray-600 leading-relaxed" data-id="element-371">
                {tech.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}